

export const fileUploadFetch = async (url, model) => {
  let token = localStorage.getItem("token");
  try {
    const response = await fetch(url, {
      method: "POST",
      body: model,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const processResult = await response.json();
    return processResult;
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const fileUploadFetchForGuest = async (url, model) => {
  let token = localStorage.getItem("token");
  try {
    const response = await fetch(url, {
      method: "POST",
      body: model,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const processResult = await response.json();
    return processResult;
  } catch (error) {
    console.error(error);
    return { success: false, message: error.message };
  }
};
